import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "flex min-h-0 flex-1 flex-col"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_4 = {
  key: 0,
  class: "w-full"
};
const _hoisted_5 = {
  class: "data-table min-w-[1280px]"
};
const _hoisted_6 = {
  class: "data-table-head"
};
const _hoisted_7 = {
  class: "data-table-th text-left data-table-sticky-left data-table-sticky-head data-table-sticky-identity"
};
const _hoisted_8 = {
  key: 0,
  class: "data-table-th text-left"
};
const _hoisted_9 = {
  key: 1,
  class: "data-table-th text-left"
};
const _hoisted_10 = {
  key: 2,
  class: "data-table-th text-left"
};
const _hoisted_11 = {
  class: "data-table-th text-left"
};
const _hoisted_12 = {
  class: "data-table-th text-left"
};
const _hoisted_13 = {
  class: "data-table-th text-left"
};
const _hoisted_14 = {
  class: "data-table-th is-right"
};
const _hoisted_15 = {
  class: "data-table-th is-center"
};
const _hoisted_16 = {
  class: "data-table-th is-center"
};
const _hoisted_17 = {
  class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
};
const _hoisted_18 = {
  class: "data-table-body data-table-skeleton"
};
const _hoisted_19 = {
  key: 0,
  class: "data-table-td"
};
const _hoisted_20 = {
  key: 1,
  class: "data-table-td"
};
const _hoisted_21 = {
  key: 2,
  class: "data-table-td"
};
const _hoisted_22 = {
  class: "mb-2 text-lg font-medium text-slate-900"
};
const _hoisted_23 = {
  class: "text-slate-500"
};
const _hoisted_24 = {
  key: 2,
  class: "data-table min-w-[1280px]"
};
const _hoisted_25 = {
  class: "data-table-head"
};
const _hoisted_26 = {
  class: "data-table-th text-left data-table-sticky-left data-table-sticky-head data-table-sticky-identity"
};
const _hoisted_27 = {
  key: 0,
  class: "data-table-th text-left"
};
const _hoisted_28 = {
  key: 1,
  class: "data-table-th text-left"
};
const _hoisted_29 = {
  key: 2,
  class: "data-table-th text-left"
};
const _hoisted_30 = {
  class: "data-table-th text-left"
};
const _hoisted_31 = {
  class: "data-table-th text-left"
};
const _hoisted_32 = {
  class: "data-table-th text-left"
};
const _hoisted_33 = {
  class: "data-table-th is-right"
};
const _hoisted_34 = {
  class: "data-table-th is-center"
};
const _hoisted_35 = {
  class: "data-table-th is-center"
};
const _hoisted_36 = {
  class: "data-table-th is-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
};
const _hoisted_37 = {
  class: "data-table-body"
};
const _hoisted_38 = {
  class: "data-table-td data-table-sticky-left data-table-sticky-identity"
};
const _hoisted_39 = {
  class: "flex items-center gap-3"
};
const _hoisted_40 = {
  class: "data-table-cell-title"
};
const _hoisted_41 = {
  class: "data-table-cell-meta"
};
const _hoisted_42 = {
  key: 0,
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_43 = ["onClick"];
const _hoisted_44 = {
  key: 1,
  class: "data-table-inline-tag text-slate-500"
};
const _hoisted_45 = {
  key: 1,
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_46 = {
  key: 2,
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_47 = {
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_48 = {
  class: "flex items-center gap-2"
};
const _hoisted_49 = {
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_50 = {
  class: "data-table-td text-sm text-slate-600"
};
const _hoisted_51 = {
  class: "data-table-td is-right text-sm font-medium text-slate-900"
};
const _hoisted_52 = {
  class: "data-table-td is-center"
};
const _hoisted_53 = {
  class: "flex flex-col items-center gap-1.5"
};
const _hoisted_54 = ["title", "aria-label", "onClick"];
const _hoisted_55 = {
  class: "data-table-td is-center text-sm text-slate-600"
};
const _hoisted_56 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_57 = {
  class: "flex items-center justify-center gap-2"
};
const _hoisted_58 = ["title", "aria-label", "onClick"];
const _hoisted_59 = ["title", "aria-label", "onClick"];
const _hoisted_60 = ["title", "aria-label"];
import { computed } from 'vue';
import AppPagination from '@/components/AppPagination.vue';
export default {
  __name: 'OrderListTable',
  props: {
    orders: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({
        current: 1,
        size: 20,
        total: 0,
        pages: 0
      })
    },
    showPlanColumn: {
      type: Boolean,
      default: true
    },
    showCustomerColumn: {
      type: Boolean,
      default: true
    },
    showCompanyColumn: {
      type: Boolean,
      default: true
    },
    showEditAction: {
      type: Boolean,
      default: true
    },
    showStatusAction: {
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    editPermission: {
      type: [String, Array],
      default: 'order:edit'
    },
    statusEditPermission: {
      type: [String, Array],
      default: 'order:status:edit'
    },
    compactEmpty: {
      type: Boolean,
      default: false
    },
    emptyDescription: {
      type: String,
      default: '\u60a8\u53ef\u4ee5\u5728\u8ba2\u5355\u7ba1\u7406\u4e2d\u7ee7\u7eed\u8ddf\u8fdb\u670d\u52a1\u6267\u884c\u3002'
    }
  },
  emits: ['detail', 'plan-click', 'edit', 'status-change', 'page-change', 'size-change', 'approval-detail'],
  setup(__props, {
    emit: __emit
  }) {
    const text = {
      "orderInfo": "订单信息",
      "plan": "所属方案",
      "customer": "客户",
      "company": "客户企业",
      "owner": "规划师",
      "executor": "执行人",
      "servicePeriod": "服务周期",
      "amount": "订单金额",
      "status": "状态",
      "createTime": "创建时间",
      "action": "操作",
      "empty": "暂无订单数据",
      "pendingApproval": "待审批",
      "pending": "待确认",
      "executing": "执行中",
      "completed": "已完成",
      "cancelled": "已取消",
      "rejected": "已驳回",
      "unknown": "未知",
      "viewDetail": "查看详情",
      "viewApproval": "查看审批详情",
      "edit": "编辑",
      "changeStatus": "变更状态",
      "total": "共",
      "item": "条",
      "prev": "上一页",
      "next": "下一页",
      "perPage": "每页",
      "emptyDescription": "您可以在订单管理中继续跟踪服务执行。"
    };
    const statusOptions = [{
      label: text.pending,
      value: 0
    }, {
      label: text.executing,
      value: 1
    }, {
      label: text.completed,
      value: 2
    }, {
      label: text.cancelled,
      value: 3
    }, {
      label: text.rejected,
      value: 4
    }];
    const statusMap = {
      '-1': {
        text: text.pendingApproval,
        class: 'bg-amber-100 text-amber-700'
      },
      0: {
        text: text.pending,
        class: 'bg-slate-100 text-slate-600'
      },
      1: {
        text: text.executing,
        class: 'bg-blue-100 text-blue-700'
      },
      2: {
        text: text.completed,
        class: 'bg-green-100 text-green-700'
      },
      3: {
        text: text.cancelled,
        class: 'bg-red-100 text-red-700'
      },
      4: {
        text: text.rejected,
        class: 'bg-orange-100 text-orange-700'
      }
    };
    const props = __props;
    const emit = __emit;
    const emptyStateClass = computed(() => {
      if (props.compactEmpty) {
        return 'rounded-lg border border-dashed border-slate-200 py-10 text-center text-sm text-slate-500';
      }
      return 'py-16 text-center';
    });
    const paginationClass = computed(() => {
      if (props.compactEmpty) {
        return 'pagination-bridge';
      }
      return 'pagination-bridge';
    });
    const getStatusClass = status => statusMap[status]?.class || 'bg-slate-100 text-slate-600';
    const getStatusText = status => statusMap[status]?.text || text.unknown;
    const hasApprovalInstance = order => order?.pendingApprovalInstanceId != null;
    const formatAmount = amount => Number(amount || 0).toLocaleString();
    const canEdit = order => order.status !== 2 && order.status !== 3;
    const formatServicePeriod = order => {
      const start = order?.serviceStart || '-';
      const end = order?.serviceEnd || '-';
      return `${start} ~ ${end}`;
    };
    const getAvailableStatusOptions = currentStatus => {
      switch (currentStatus) {
        case 1:
          return statusOptions.filter(status => status.value === 2 || status.value === 3);
        case 3:
          return statusOptions.filter(status => status.value === 1);
        default:
          return [];
      }
    };
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [__props.loading ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("table", _hoisted_5, [_createElementVNode("thead", _hoisted_6, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_7, _toDisplayString(text.orderInfo), 1), __props.showPlanColumn ? (_openBlock(), _createElementBlock("th", _hoisted_8, _toDisplayString(text.plan), 1)) : _createCommentVNode("", true), __props.showCustomerColumn ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(text.customer), 1)) : _createCommentVNode("", true), __props.showCompanyColumn ? (_openBlock(), _createElementBlock("th", _hoisted_10, _toDisplayString(text.company), 1)) : _createCommentVNode("", true), _createElementVNode("th", _hoisted_11, _toDisplayString(text.owner), 1), _createElementVNode("th", _hoisted_12, _toDisplayString(text.executor), 1), _createElementVNode("th", _hoisted_13, _toDisplayString(text.servicePeriod), 1), _createElementVNode("th", _hoisted_14, _toDisplayString(text.amount), 1), _createElementVNode("th", _hoisted_15, _toDisplayString(text.status), 1), _createElementVNode("th", _hoisted_16, _toDisplayString(text.createTime), 1), _createElementVNode("th", _hoisted_17, _toDisplayString(text.action), 1)])]), _createElementVNode("tbody", _hoisted_18, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, n => {
        return _createElementVNode("tr", {
          key: n,
          class: "animate-pulse"
        }, [_cache[5] || (_cache[5] = _createElementVNode("td", {
          class: "data-table-td data-table-sticky-left data-table-sticky-identity"
        }, [_createElementVNode("div", {
          class: "flex items-center gap-3"
        }, [_createElementVNode("div", {
          class: "h-10 w-10 rounded-lg bg-slate-200"
        }), _createElementVNode("div", null, [_createElementVNode("div", {
          class: "mb-1 h-4 w-32 rounded bg-slate-200"
        }), _createElementVNode("div", {
          class: "h-3 w-24 rounded bg-slate-200"
        })])])], -1)), __props.showPlanColumn ? (_openBlock(), _createElementBlock("td", _hoisted_19, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
          class: "h-6 w-20 rounded bg-slate-200"
        }, null, -1)]))])) : _createCommentVNode("", true), __props.showCustomerColumn ? (_openBlock(), _createElementBlock("td", _hoisted_20, [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
          class: "h-4 w-20 rounded bg-slate-200"
        }, null, -1)]))])) : _createCommentVNode("", true), __props.showCompanyColumn ? (_openBlock(), _createElementBlock("td", _hoisted_21, [...(_cache[4] || (_cache[4] = [_createElementVNode("div", {
          class: "h-4 w-24 rounded bg-slate-200"
        }, null, -1)]))])) : _createCommentVNode("", true), _cache[6] || (_cache[6] = _createElementVNode("td", {
          class: "data-table-td"
        }, [_createElementVNode("div", {
          class: "flex items-center gap-2"
        }, [_createElementVNode("div", {
          class: "h-6 w-6 rounded-full bg-slate-200"
        }), _createElementVNode("div", {
          class: "h-4 w-16 rounded bg-slate-200"
        })])], -1)), _cache[7] || (_cache[7] = _createElementVNode("td", {
          class: "data-table-td"
        }, [_createElementVNode("div", {
          class: "h-4 w-16 rounded bg-slate-200"
        })], -1)), _cache[8] || (_cache[8] = _createElementVNode("td", {
          class: "data-table-td"
        }, [_createElementVNode("div", {
          class: "h-4 w-32 rounded bg-slate-200"
        })], -1)), _cache[9] || (_cache[9] = _createElementVNode("td", {
          class: "data-table-td is-right"
        }, [_createElementVNode("div", {
          class: "ml-auto h-4 w-20 rounded bg-slate-200"
        })], -1)), _cache[10] || (_cache[10] = _createElementVNode("td", {
          class: "data-table-td is-center"
        }, [_createElementVNode("div", {
          class: "mx-auto h-6 w-14 rounded-full bg-slate-200"
        })], -1)), _cache[11] || (_cache[11] = _createElementVNode("td", {
          class: "data-table-td is-center"
        }, [_createElementVNode("div", {
          class: "mx-auto h-4 w-24 rounded bg-slate-200"
        })], -1)), _cache[12] || (_cache[12] = _createElementVNode("td", {
          class: "data-table-td data-table-sticky-right data-table-sticky-action"
        }, [_createElementVNode("div", {
          class: "flex items-center justify-center gap-2"
        }, [_createElementVNode("div", {
          class: "h-8 w-8 rounded bg-slate-200"
        }), _createElementVNode("div", {
          class: "h-8 w-8 rounded bg-slate-200"
        })])], -1))]);
      }), 64))])])])) : __props.orders.length === 0 ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([emptyStateClass.value, __props.compactEmpty ? 'data-table-empty is-compact' : 'data-table-empty'])
      }, [__props.compactEmpty ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(text.empty), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_cache[13] || (_cache[13] = _createElementVNode("div", {
        class: "mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-slate-100"
      }, [_createElementVNode("svg", {
        class: "h-10 w-10 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
      })])], -1)), _createElementVNode("h3", _hoisted_22, _toDisplayString(text.empty), 1), _createElementVNode("p", _hoisted_23, _toDisplayString(__props.emptyDescription), 1)], 64))], 2)) : (_openBlock(), _createElementBlock("table", _hoisted_24, [_createElementVNode("thead", _hoisted_25, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_26, _toDisplayString(text.orderInfo), 1), __props.showPlanColumn ? (_openBlock(), _createElementBlock("th", _hoisted_27, _toDisplayString(text.plan), 1)) : _createCommentVNode("", true), __props.showCustomerColumn ? (_openBlock(), _createElementBlock("th", _hoisted_28, _toDisplayString(text.customer), 1)) : _createCommentVNode("", true), __props.showCompanyColumn ? (_openBlock(), _createElementBlock("th", _hoisted_29, _toDisplayString(text.company), 1)) : _createCommentVNode("", true), _createElementVNode("th", _hoisted_30, _toDisplayString(text.owner), 1), _createElementVNode("th", _hoisted_31, _toDisplayString(text.executor), 1), _createElementVNode("th", _hoisted_32, _toDisplayString(text.servicePeriod), 1), _createElementVNode("th", _hoisted_33, _toDisplayString(text.amount), 1), _createElementVNode("th", _hoisted_34, _toDisplayString(text.status), 1), _createElementVNode("th", _hoisted_35, _toDisplayString(text.createTime), 1), _createElementVNode("th", _hoisted_36, _toDisplayString(text.action), 1)])]), _createElementVNode("tbody", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orders, order => {
        return _openBlock(), _createElementBlock("tr", {
          key: order.id,
          class: "data-table-row"
        }, [_createElementVNode("td", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-blue-100"
        }, [_createElementVNode("svg", {
          class: "h-5 w-5 text-blue-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
        })])], -1)), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_40, _toDisplayString(order.productNameSnapshot), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(order.orderNo), 1)])])]), __props.showPlanColumn ? (_openBlock(), _createElementBlock("td", _hoisted_42, [order.planName ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "data-table-inline-tag is-clickable",
          onClick: $event => emit('plan-click', order)
        }, _toDisplayString(order.planName), 9, _hoisted_43)) : (_openBlock(), _createElementBlock("span", _hoisted_44, "-"))])) : _createCommentVNode("", true), __props.showCustomerColumn ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(order.customerName || '-'), 1)) : _createCommentVNode("", true), __props.showCompanyColumn ? (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString(order.companyName || '-'), 1)) : _createCommentVNode("", true), _createElementVNode("td", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "flex h-6 w-6 items-center justify-center rounded-full bg-primary-50"
        }, [_createElementVNode("svg", {
          class: "h-3 w-3 text-primary-600",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        })])], -1)), _createElementVNode("span", null, _toDisplayString(order.ownerUserName || '-'), 1)])]), _createElementVNode("td", _hoisted_49, _toDisplayString(order.executorName || '-'), 1), _createElementVNode("td", _hoisted_50, _toDisplayString(formatServicePeriod(order)), 1), _createElementVNode("td", _hoisted_51, "¥" + _toDisplayString(formatAmount(order.amount)), 1), _createElementVNode("td", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("span", {
          class: _normalizeClass(['status-badge', getStatusClass(order.status)])
        }, _toDisplayString(getStatusText(order.status)), 3), hasApprovalInstance(order) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "table-action-button is-purple",
          title: text.viewApproval,
          "aria-label": text.viewApproval,
          onClick: $event => emit('approval-detail', order)
        }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
        })], -1)]))], 8, _hoisted_54)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.$formatDateTime(order.createTime)), 1), _createElementVNode("td", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("button", {
          class: "table-action-button is-primary",
          title: text.viewDetail,
          "aria-label": text.viewDetail,
          onClick: $event => emit('detail', order)
        }, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
        }), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        })], -1)]))], 8, _hoisted_58), __props.showEditAction && canEdit(order) ? _withDirectives((_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "table-action-button is-primary",
          title: text.edit,
          "aria-label": text.edit,
          onClick: $event => emit('edit', order)
        }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        })], -1)]))], 8, _hoisted_59)), [[_directive_permission, __props.editPermission]]) : _createCommentVNode("", true), __props.showStatusAction && getAvailableStatusOptions(order.status).length > 0 ? _withDirectives((_openBlock(), _createBlock(_component_el_dropdown, {
          key: 1,
          trigger: "click",
          onCommand: status => emit('status-change', {
            order,
            status
          })
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAvailableStatusOptions(order.status), status => {
              return _openBlock(), _createBlock(_component_el_dropdown_item, {
                key: status.value,
                command: status.value
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(status.label), 1)]),
                _: 2
              }, 1032, ["command"]);
            }), 128))]),
            _: 2
          }, 1024)]),
          default: _withCtx(() => [_createElementVNode("button", {
            class: "table-action-button is-neutral",
            title: text.changeStatus,
            "aria-label": text.changeStatus
          }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
          })], -1)]))], 8, _hoisted_60)]),
          _: 2
        }, 1032, ["onCommand"])), [[_directive_permission, __props.statusEditPermission]]) : _createCommentVNode("", true)])])]);
      }), 128))])]))])]), __props.orders.length > 0 && __props.showPagination ? (_openBlock(), _createBlock(AppPagination, {
        key: 0,
        pagination: __props.pagination,
        "page-sizes": [10, 20, 50],
        class: _normalizeClass(paginationClass.value),
        "total-label": `${text.total} `,
        "total-suffix": ` ${text.item}`,
        "page-size-label": text.perPage,
        "page-size-suffix": text.item,
        "prev-text": text.prev,
        "next-text": text.next,
        onPageChange: _cache[0] || (_cache[0] = $event => emit('page-change', $event)),
        onSizeChange: _cache[1] || (_cache[1] = $event => emit('size-change', $event))
      }, null, 8, ["pagination", "class", "total-label", "total-suffix", "page-size-label", "page-size-suffix", "prev-text", "next-text"])) : _createCommentVNode("", true)]);
    };
  }
};